import { useDispatch } from 'react-redux'
import { ReduxDispatch } from '../typings/ReduxDispatch'

export const useAppDispatch = useDispatch as () => ReduxDispatch
